export default class DataBlockedUsers {
}
DataBlockedUsers.Breadcrumbs = [
    {
        to: "/",
        text: "Home",
    },
    {
        to: "/admin/blocked-users/list",
        text: "Blocked Users",
        disabled: true,
    },
];
DataBlockedUsers.TableHeaders = [
    {
        text: "Email",
        value: "email",
    },
    {
        text: "Fiscal Code",
        value: "fiscalCode",
    },
    {
        text: "Phone",
        value: "phone",
    },
    {
        text: "Actions",
        value: "action",
        sortable: false,
    },
];
